import React, { useEffect, useState } from 'react'
import { Select, Button, Spin, Row, Col } from 'antd'
import axios from 'axios'
import AdminHeader from '../../CommonComponents/AdminHeader'
import AdminFooter from '../../CommonComponents/AdminFooter'
import {
  getChildrenList,
  GetFirAndPoliceDocById,
  IMG_URL,
} from '../../APIComponents/AdminApi'

const { Option } = Select

const PoliceInfoReport = () => {
  const [students, setStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [reportData, setReportData] = useState(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    fetchStudents()
  }, [])

  const fetchStudents = async () => {
    try {
      const res = await axios.get(getChildrenList)
      setStudents(res.data)
    } catch (err) {
      console.error(err)
    }
  }

  const fetchReport = async () => {
    if (!selectedStudent) return

    setLoading(true)
    try {
      const res = await axios.get(
        `${GetFirAndPoliceDocById}/${selectedStudent}`,
      )
      setReportData(res.data)
    } catch (err) {
      console.error(err)
    }
    setLoading(false)
  }

  const isPDF = (file) => {
    return file?.toLowerCase().endsWith('.pdf')
  }

  return (
    <>
      <AdminHeader />

      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper pb-5">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-3">
              FIR & Police Report
            </h3>
          </div>

          <Row gutter={16} className="mb-3 shadow rounded py-3 m-0 bg-white">
            <Col md={8}>
              <Select
                className="w-100"
                placeholder="Select Student"
                onChange={(val) => setSelectedStudent(val)}
              >
                {students.map((child) => (
                  <Option key={child.id} value={child.id}>
                    {child.fname} {child.mname} {child.lname} (Reg No:{' '}
                    {child.reg_no})
                  </Option>
                ))}
              </Select>
            </Col>

            <Col md={8}>
              <Button type="primary" onClick={fetchReport}>
                Show Report
              </Button>

              <Button style={{ marginLeft: 10 }} onClick={() => window.print()}>
                Print
              </Button>
            </Col>
          </Row>

          {loading ? (
            <Spin size="large" />
          ) : (
            reportData && (
              <div className="a4-page">
                {/* HEADER */}
                <div className="text-center pb-1">
                  <h2>
                    <b>सेंट क्रिस्पिन्स होम</b>
                  </h2>
                  <h5>
                    <b>FIR व पोलीस अहवाल</b>
                  </h5>
                </div>

                {/* FIR DETAILS */}
                <div className="section">
                  <div className="row m-0 p-0">
                    <div className="col-12">
                      <p>
                        <b>विद्यार्थ्याचे नाव:</b>{' '}
                        {reportData.data[0]?.student?.full_name}
                      </p>
                    </div>
                  </div>

                  {reportData.data?.map((item, i) => (
                    <div key={i}>
                      <div className="row m-0 p-0">
                        <div className="col-12 col-md-6">
                          <p>
                            <b>FIR क्रमांक:</b> {item.fir_number}
                          </p>
                        </div>
                        <div className="col-12 col-md-6">
                          <p>
                            <b>FIR तारीख:</b> {item.fir_date}
                          </p>
                        </div>
                        <div className="col-12">
                          <p>
                            <b>पोलीस स्टेशन:</b> {item.police_station_name}
                          </p>
                        </div>
                        <div className="col-12">
                          <p>
                            <b>शहर:</b> {item.city}
                          </p>
                        </div>
                        <div className="col-12">
                          <p>
                            <b>तक्रार तपशील:</b> {item.details_of_complaint}
                          </p>
                        </div>
                      </div>

                      {/* DOCUMENTS */}
                      <div className="section">
                        {item.police_documents?.map((doc, idx) => (
                          <div key={idx}>
                            <div className="row p-0 m-0">
                              {/* FIR COPY */}
                              <div className="col-12 mb-3">
                                <p>
                                  <b>FIR प्रत:</b>
                                </p>

                                {doc.fir_copy ? (
                                  isPDF(doc.fir_copy) ? (
                                    <iframe
                                      src={`${IMG_URL}${doc.fir_copy}`}
                                      title="PDF Viewer"
                                      className="pdf-viewer"
                                    />
                                  ) : (
                                    <img
                                      src={`${IMG_URL}${doc.fir_copy}`}
                                      className="doc-img"
                                      alt="home-visit"
                                    />
                                  )
                                ) : (
                                  <p>उपलब्ध नाही</p>
                                )}
                              </div>

                              {/* POLICE REPORT */}
                              <div className="col-12 mb-3">
                                <p>
                                  <b>पोलीस रिपोर्ट:</b>
                                </p>
                                {/* {doc.police_report ? (
                                  <img
                                    src={`${IMG_URL}${doc.police_report}`}
                                    className="doc-img"
                                    alt="police-report"
                                  />
                                ) : (
                                  <p>उपलब्ध नाही</p>
                                )} */}

                                {doc.police_report ? (
                                  isPDF(doc.police_report) ? (
                                    <iframe
                                      src={`${IMG_URL}${doc.police_report}`}
                                      title="PDF Viewer"
                                      className="pdf-viewer"
                                    />
                                  ) : (
                                    <img
                                      src={`${IMG_URL}${doc.police_report}`}
                                      className="doc-img"
                                      alt="home-visit"
                                    />
                                  )
                                ) : (
                                  <p>उपलब्ध नाही</p>
                                )}
                              </div>

                              {/* MEDICAL REPORT */}
                              <div className="col-12 mb-3">
                                <p>
                                  <b>वैद्यकीय तपासणी रिपोर्ट:</b>
                                </p>
                                {/* {doc.medical_examination_report ? (
                                  <img
                                    src={`${IMG_URL}${doc.medical_examination_report}`}
                                    className="doc-img"
                                    alt="medical-report"
                                  />
                                ) : (
                                  <p>उपलब्ध नाही</p>
                                )} */}

                                {doc.medical_examination_report ? (
                                  isPDF(doc.medical_examination_report) ? (
                                    <iframe
                                      src={`${IMG_URL}${doc.medical_examination_report}`}
                                      title="PDF Viewer"
                                      className="pdf-viewer"
                                    />
                                  ) : (
                                    <img
                                      src={`${IMG_URL}${doc.medical_examination_report}`}
                                      className="doc-img"
                                      alt="home-visit"
                                    />
                                  )
                                ) : (
                                  <p>उपलब्ध नाही</p>
                                )}
                              </div>

                              {/* VICTIM STATEMENT */}
                              <div className="col-12 mb-3">
                                <p>
                                  <b>पीडिताचे विधान:</b>
                                </p>
                                {/* {doc.statement_of_victim ? (
                                  <img
                                    src={`${IMG_URL}${doc.statement_of_victim}`}
                                    className="doc-img"
                                    alt="statement"
                                  />
                                ) : (
                                  <p>उपलब्ध नाही</p>
                                )} */}

                                {doc.statement_of_victim ? (
                                  isPDF(doc.statement_of_victim) ? (
                                    <iframe
                                      src={`${IMG_URL}${doc.statement_of_victim}`}
                                      title="PDF Viewer"
                                      className="pdf-viewer"
                                    />
                                  ) : (
                                    <img
                                      src={`${IMG_URL}${doc.statement_of_victim}`}
                                      className="doc-img"
                                      alt="home-visit"
                                    />
                                  )
                                ) : (
                                  <p>उपलब्ध नाही</p>
                                )}
                              </div>

                              {/* NOTES */}
                              {doc.additional_notes && (
                                <div className="mb-3">
                                  <p>
                                    <b>अतिरिक्त नोंदी:</b>{' '}
                                    {doc.additional_notes}
                                  </p>
                                </div>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )
          )}
        </div>
      </div>

      <AdminFooter />

      {/* CSS */}
      <style>{`
        .a4-page {
          width: 210mm;
          min-height: 297mm;
          padding: 20px 60px;
          background: white;
          font-family: 'Noto Sans Devanagari', sans-serif;
        }

        .section {
          margin-bottom: 20px;
        }

        .section p {
          color: black;
        }

        .text-center {
          text-align: center;
        }

        .doc-img {
          width: 100%;
          height: auto;
          max-height: 500px;
          object-fit: contain;
          margin-bottom: 15px;
          border: 1px solid black;
        }

        @media print {
          body * {
            visibility: hidden;
          }

          .a4-page, .a4-page * {
            visibility: visible;
          }

          .a4-page {
            position: absolute;
            left: 0;
            top: 0;
            width: 210mm;
          }

          .doc-img {
            page-break-inside: avoid;
            break-inside: avoid;
          }

          .section {
            page-break-inside: avoid;
          }

           /* FIX ROW */
          .row {
            display: flex !important;
            flex-wrap: wrap !important;
          }

          /*  FIX COLUMNS */
          .col-md-6 {
            width: 50% !important;
            float: left !important;
          }

          .col-md-4 {
            width: 33.33% !important;
            float: left !important;
          }

          .col-md-8 {
            width: 66.66% !important;
            float: left !important;
          }

          .col-md-12 {
            width: 100% !important;
            float: left !important;
          }

          /* remove extra spacing */
          .row > div {
            padding: 2px !important;
          }

          .certificate-img {
            page-break-inside: avoid;
            break-inside: avoid;
          }
        }
      `}</style>
    </>
  )
}

export default PoliceInfoReport
